import { app } from '../../../../app';

import {
    toDirectoryDTO
} from '../directory-integration.functions';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage', {
        url: '/manage/:directoryId',
        redirectTo: 'company.directory-integration.manage.main',
        component: 'companyDirectoryIntegrationManage',
        resolve: {
            $breadcrumbs,
            directory,
            directoryId,
            directoryType,
        },
    });
}

/** @ngInject */
function $breadcrumbs(directory) {
    return [{title: directory.name}];
}

/** @ngInject */
function directory(companyId, DirectoriesResource, directoryId, directoryType) {
    return DirectoriesResource.getDirectory(companyId, directoryId, directoryType)
        .then(directory => (toDirectoryDTO(directory)));
}

/** @ngInject */
function directoryId($stateParams) {
    return $stateParams.directoryId;
}

/** @ngInject */
function directoryType(directories, directoryId) {
    /** @ngInject */
    let current = directories.find(directory => directory.id === directoryId);
    return current.type;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/directory-manage.state.js